import { render, staticRenderFns } from "./custom-sidebar.vue?vue&type=template&id=7f2c01dc&scoped=true"
import script from "./custom-sidebar.vue?vue&type=script&lang=js"
export * from "./custom-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2c01dc",
  null
  
)

export default component.exports